var SupportLocalStatusAndNotesPresentation;

SupportLocalStatusAndNotesPresentation = {
  editable: {
    status: "Can be edited until <span class='localtime'>{{editable_deadline}}</span>",
    notes: "You can edit this order until <span class='longlocaltime'>{{editable_deadline}}</span>. " + I18n.translate('js.modules.notes.editable_notes_message')
  },
  not_editable: {
    purchased: {
      status: "Ready to print",
      notes: I18n.translate('js.modules.notes.not_editable_notes_message')
    },
    redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    },
    available: {
      status: "Ready to print",
      notes: I18n.translate('js.modules.notes.not_editable_notes_message')
    },
    expired: {
      status: "Expired",
      notes: ""
    },
    expired_unredeemed: {
      status: "Promotional value expired on <span class='utctime'>{{expiration_date}}</span>",
      notes: I18n.translate('js.modules.notes.not_editable_expired_unredeemed_message') + ", you can still redeem it at <strong>{{merchant_name}}</strong> for the amount you paid for it."
    },
    expired_redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    }
  }
};

module.exports = SupportLocalStatusAndNotesPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9sb2NhbF9tZXNzYWdlcy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC9wcmVzZW50ZXJzL2xvY2FsX21lc3NhZ2VzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLHNDQUFBLEdBQ0M7RUFBQSxRQUFBLEVBQ0M7SUFBQSxNQUFBLEVBQVEsMEVBQVI7SUFDQSxLQUFBLEVBQVEsMEZBQUEsR0FBNkYsSUFBSSxDQUFDLFNBQUwsQ0FBZSx5Q0FBZixDQURyRztHQUREO0VBR0EsWUFBQSxFQUNDO0lBQUEsU0FBQSxFQUNDO01BQUEsTUFBQSxFQUFRLGdCQUFSO01BQ0EsS0FBQSxFQUFRLElBQUksQ0FBQyxTQUFMLENBQWUsNkNBQWYsQ0FEUjtLQUREO0lBR0EsUUFBQSxFQUNDO01BQUEsTUFBQSxFQUFRLDBEQUFSO01BQ0EsS0FBQSxFQUFPLEVBRFA7S0FKRDtJQU1BLFNBQUEsRUFDQztNQUFBLE1BQUEsRUFBUSxnQkFBUjtNQUNBLEtBQUEsRUFBTyxJQUFJLENBQUMsU0FBTCxDQUFlLDZDQUFmLENBRFA7S0FQRDtJQVNBLE9BQUEsRUFDQztNQUFBLE1BQUEsRUFBUSxTQUFSO01BQ0EsS0FBQSxFQUFPLEVBRFA7S0FWRDtJQVlBLGtCQUFBLEVBQ0M7TUFBQSxNQUFBLEVBQVEsK0VBQVI7TUFDQSxLQUFBLEVBQU8sSUFBSSxDQUFDLFNBQUwsQ0FBZSwwREFBZixDQUFBLEdBQTZFLGlHQURwRjtLQWJEO0lBZUEsZ0JBQUEsRUFDQztNQUFBLE1BQUEsRUFBUSwwREFBUjtNQUNBLEtBQUEsRUFBTyxFQURQO0tBaEJEO0dBSkQ7OztBQXVCRCxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
